export default __webpack_public_path__ + "static/media/darkovy_poukaz.64dd92b8.jpg";